import { FC } from "react";
import { IconPropsType } from ".";

export const AddDebt: FC<IconPropsType> = (props) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 29 29"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.2 6H4C2.34315 6 1 7.34315 1 9V25C1 26.6569 2.34315 28 4 28H15C16.6569 28 18 26.6569 18 25V17"
        stroke={props.color}
      />
      <path
        d="M13.2662 11.3261L12.3609 12.2314L13.6725 13.543L14.5778 12.6377L20.9009 10.5117L15.1299 4.74062L13.2662 11.3261Z"
        stroke={props.color}
        strokeLinejoin="round"
      />
      <path
        d="M17.7034 4.93571C18.6291 4.01005 20.1299 4.01005 21.0555 4.93571C21.9812 5.86137 21.9812 7.36216 21.0555 8.28783"
        stroke={props.color}
      />
      <path
        d="M15.9257 3.25964C16.8514 2.33398 20.3176 1.20155 22.4441 3.25964C24.6859 5.42946 23.9623 8.85232 23.0366 9.77798"
        stroke={props.color}
      />
      <path d="M14.5 12.5L17 15" stroke={props.color} strokeLinejoin="round" />
      <circle cx="9.5" cy="12.5" r="1.5" fill={props.color} />
      <circle cx="9.5" cy="17.5" r="1.5" fill={props.color} />
      <circle cx="9.5" cy="22.5" r="1.5" fill={props.color} />
    </svg>
  );
};
